invHdApp.controller('OrderController', ['$scope', 'Order', '$location', '$filter', '$interval',
	'ngAudio', '$routeParams', '$rootScope', '$window', '$http', '$timeout', 'RouteList',
	function ($scope, Order, $location, $filter, ngAudio, $routeParams, $rootScope, $window, $http, $interval, $timeout, RouteList) {

		//var successSound = ngAudio.load("sounds/success.mp3");
		var routeOptimizationDirectionsDisplay = [];
		var routeOptimizationWorkerOrders = [];

		$scope.statuses = {
			work: 1,
			worker: 1
		};
		$scope.filterPanel = false;
		$scope.tab = 0;

		$scope.filterData = {
			workers: [],
			workSteps: [],
			created_at: {
				startDate: null,
				endDate: null
			},
			scheduled_time: {
				startDate: null,
				endDate: null
			}
		}

		var calculatedOrder = [];

		if (window.localStorage.getItem('map_detail') !== null) {
			$scope.mapDetail = JSON.parse(window.localStorage.getItem('map_detail'));
		} else {
			$scope.mapDetail = {
				traffic: false,
				detail_name: true,
				darkColor: false
			}
		}
		var geocoder, interval;

		$scope.getWorkerOrders = function (item) {
			return item.worker_id === $scope.sWorker.id;
		}

		$scope.$on('teamChange', function (event, data, nextParams, fromState) {
			$scope.filterData.team = data !== null ? data.id : null;
			$scope.init();
		});

		$scope.export = function (page) {
			$scope.filterData.export = true;
			$scope.init('export');
		}

		$scope.searchOrder = function (term) {
			$scope.filterData.term = term;
			$scope.init();
		}

		$scope.newRouteData = function () {
			$location.path('routes');
			setTimeout(() => {
				$scope.newData();
			}, 300);
		}

		$scope.init = function (type) {
			if (typeof type !== 'undefined' && type == 'clear') {
				$scope.filterData = {
					term: '',
					workers: [],
					workSteps: [],
					created_at: {
						startDate: null,
						endDate: null
					},
					scheduled_time: {
						startDate: null,
						endDate: null
					}
				}
			}

			$scope.getPage = function (page) {
				$scope.filterData.page = page;
				$scope.init();
			}

			if ($routeParams.real_order) {
				$scope.filterData.real_order = true;
				$rootScope.realOrder = true;
			} else {
				$rootScope.realOrder = false;
			}

			Order.dashboard($scope.filterData).success(function (data, status, headers, config) {
				if (typeof type !== undefined && type == 'export') {
					$scope.filterData.export = false;
					window.location.href = data.url;
				} else {
					$scope.data = data;
					$scope.paginate = {
						current_page: data.orders.current_page,
						from: data.orders.from,
						last_page: data.orders.last_page,
						per_page: data.orders.per_page,
						to: data.orders.to,
						total: data.orders.total
					};
					$scope.data.orders = data.orders.data;
					$scope.data.steps.unshift({
						id: 0,
						name: 'Oluşturuldu'
					});
					$scope.markers = {
						'order': {},
						'worker': {}
					};
					$scope.orderMarkers = {};
					$scope.infowindows = [];
					$scope.infowindowsOrder = [];
					var bounds = [];

					// Initialize Yandex Map
					if (!$scope.map) {
						$scope.map = new ymaps.Map('map', {
							center: [38.7267005, 35.2151109],
							zoom: 6,
							controls: ['zoomControl', 'fullscreenControl']
						});
					} else {
						$scope.map.geoObjects.removeAll();
					}

					const mapContainer = document.getElementById('map');
					mapContainer.style.zoom = 1.15;

					$scope.data.orders.forEach(element => {
						var marker = $scope.createOrderMarker(element);
						if (marker) {
							bounds.push(marker.geometry.getCoordinates());
						}
					});

					$scope.data.workers.forEach(element => {
						var marker = $scope.createWorkerMarker(element);
						if (marker) {
							bounds.push(marker.geometry.getCoordinates());
						}
					});

					// Set bounds if we have any points
					if (bounds.length > 0 && false) {
						$scope.map.setBounds(bounds, {
							checkZoomRange: true,
							duration: 500,
							timingFunction: 'ease-in-out',
							useMapMargin: true
						}).then(function() {
							if ($scope.map.getZoom() > 15) {
								$scope.map.setZoom(15);
							}
						});
					}
				}
			});
		}

		$scope.createOrderMarker = function (order) {
			if (!order || !order.location || !order.id) {
				console.error('Invalid order data:', order);
				return null;
			}

			// Initialize orderMarkers if it doesn't exist
			$scope.orderMarkers = $scope.orderMarkers || {};
			$scope.workerMarkers = $scope.workerMarkers || {};

			var location = [Number(order.location.latitude), Number(order.location.longitude)];

			// Order marker HTML
			var html = '<div class="map-marker">';
			if (order.status && order.status.value === 'complete') {
				html = '<div class="map-marker map-marker-success"><img src="/img/icons/complete.png" alt="" width="30px">';
			} else if (order.status && order.status.value === 'fail') {
				html = '<div class="map-marker map-marker-fail"><img src="/img/icons/fail.png" alt="" width="30px">';
			} else {
				html += '<img src="/img/icons/continue.png" alt="" width="30px">';
			}
			html += '</div>';

			// Create balloon content
			var balloonContent = '<div id="iw-container">' +
				'<div class="iw-content">' +
				'<strong>#' + order.id + '</strong>';

			if (order.name && order.name !== null) {
				balloonContent += ' - ' + order.name;
			}

			if (order.special_value) {
				balloonContent += ' - <strong>' + order.special_value + '</strong>';
			}

			balloonContent += '<hr style="margin:17px 0">' +
				'<p>' + order.customer.customer_name + '</p>' +
				'<p>' + order.location.name + '</p>' +
				'<p>' + order.location.address + '</p>' +
				'<div class="row">' +
				'<div class="col-md-6">' +
				'<button type="button" onclick="angular.element(this).scope().$apply(function() { angular.element(this).scope().zoomIn(' + order.location.latitude + ', ' + order.location.longitude + '); })" class="gk-button blue btn-xs"><i class="fa fa-search-plus"></i></button>' +
				'</div>' +
				'<div class="col-md-6">' +
				'<button type="button" onclick="angular.element(this).scope().$apply(function() { angular.element(this).scope().getOrderDetails(' + order.id + '); })" class="gk-button blue btn-xs pull-right"><i class="fa fa-eye"></i></button>' +
				'</div>' +
				'</div>';

			if (order.worker) {
				balloonContent += '<p>' + order.worker.full_name + '</p>';
			}

			balloonContent += '</div></div>';

			// Create placemark
			var placemark = new ymaps.Placemark(location, {
				hintContent: '#' + order.id,
				balloonContent: balloonContent
			}, {
				iconLayout: 'default#imageWithContent',
				iconImageHref: 'transparent.png',
				iconImageSize: [30, 30],
				iconImageOffset: [-15, -15],
				iconContentLayout: ymaps.templateLayoutFactory.createClass(html),
				balloonMaxWidth: 300,
				hideIconOnBalloonOpen: false,
				balloonOffset: [0, -40]
			});

			// Click event listener
			placemark.events.add('click', function (e) {
				e.stopPropagation();
				setTimeout(function() {
					placemark.balloon.open();
					$scope.$apply();
				  }, 1000);
			});

			// Remove existing marker if it exists
			if ($scope.orderMarkers[order.id]) {
				$scope.map.geoObjects.remove($scope.orderMarkers[order.id]);
			}

			// Add new marker
			$scope.map.geoObjects.add(placemark);
			$scope.orderMarkers[order.id] = placemark;

			return placemark;
		}

		$scope.createWorkerMarker = function (worker) {
			if (worker.lat.length == 0) return false;

			var html = '<div class="map-worker-marker"><img src="/img/icons/worker.png" alt="" width="30px"></div>';

			// Create balloon content
			var balloonContent = '<div id="iw-container">' +
				'<div class="iw-content">' +
				'<div class="btn-group pull-right">' +
				'<button type="button" onclick="angular.element(this).scope().$apply(function() { angular.element(this).scope().zoomIn(' + worker.lat + ', ' + worker.lon + '); })" class="gk-button blue btn-xs mr-10"><i class="fa fa-search-plus"></i></button>' +
				'<button type="button" onclick="angular.element(this).scope().$apply(function() { angular.element(this).scope().getWorkerDetails(' + worker.id + '); })" class="gk-button blue btn-xs"><i class="fa fa-eye"></i></button>' +
				'</div>' +
				'<div class="iw-subTitle">' + worker.full_name + '</div>' +
				'<img src="https://s3.eu-central-1.amazonaws.com/herodispatcher/' + worker.profile_photo + '" class="img-circle" height="90" width="90">' +
				'<p><strong> Doğruluk : </strong>' + Math.round(worker.accuracy) + ' Metre</p>';

			if ($scope.authenticatedUser.setting.last_location_time) {
				balloonContent += '<p><strong> Son Konum Zamanı :</strong>' + moment(worker.timestamp).format('D MMM, HH:mm');
			}

			balloonContent += '</div></div>';

			// Create placemark
			var placemark = new ymaps.Placemark([Number(worker.lat), Number(worker.lon)], {
				hintContent: worker.full_name,
				balloonContent: balloonContent
			}, {
				iconLayout: 'default#imageWithContent',
				iconImageHref: 'transparent.png',
				iconImageSize: [30, 30],
				iconImageOffset: [-15, -15],
				iconContentLayout: ymaps.templateLayoutFactory.createClass(html),
				balloonMaxWidth: 300,
				hideIconOnBalloonOpen: false,
				balloonOffset: [0, -40]
			});

			// Click event listener
			placemark.events.add('click', function (e) {
				e.stopPropagation();
				setTimeout(function() {
					$scope.$apply(function() {
						placemark.balloon.open();
					});
				}, 1000);
			});

			// Remove existing marker if it exists
			if ($scope.workerMarkers[worker.id]) {
				$scope.map.geoObjects.remove($scope.workerMarkers[worker.id]);
			}

			// Add new marker
			$scope.map.geoObjects.add(placemark);
			$scope.workerMarkers[worker.id] = placemark;

			return placemark;
		}

		$scope.$on('refresh_data', function () {
			console.log('refreshing map...')
			$scope.init();
		}, true);

		$scope.clearFilter = function (page) {
			$scope.filterData = {
				workers: [],
				workSteps: [],
				created_at: {
					startDate: null,
					endDate: null
				},
				scheduled_time: {
					startDate: null,
					endDate: null
				}
			}
			$scope.filterProp = [];
			$scope.refreshData('map');
		}

		$scope.$on('$routeChangeStart', function (next, current) {
			//clearInterval(interval);
		});

		$scope.$on('new_order', function (event, data, nextParams, fromState) {

			if (typeof data[0] !== 'undefined') {
				data.orders.forEach(function (element) {
					addOrder(element);
				}, this);
			} else {
				if (typeof data.order !== 'undefined') {
					addOrder(data.order);
				} else {
					data.orders.forEach(function (element) {
						addOrder(element);
					}, this);
				}
			}
		});

		function addOrder(data) {
			$scope.infowindowsOrder.forEach(function (element) {
				element.close();
			}, this);
			if ($scope.filterData.scheduled_time.startDate == null) {
				var order = find($scope.data.orders, data.id);
				if (typeof order !== 'undefined') {
					angular.merge(order, data);
				} else {
					$scope.data.orders.unshift(data);
				}

				$scope.createOrderMarker(order);
				$scope.infowindowsOrder[order.id].open($scope.map, $scope.markers['order'][order.id]);
			} else {
				var date1 = moment(data.scheduled_time).format('DD/MM/YYYY'),
					date2 = moment($scope.filterData.scheduled_time.startDate).format('DD/MM/YYYY');
				if (date1 == date2) {
					var order = find($scope.data.orders, data.id);
					if (typeof order !== 'undefined') {
						angular.merge(order, data);
					} else {
						$scope.data.orders.unshift(data);
					}

					$scope.createOrderMarker(order);
					$scope.infowindowsOrder[order.id].open($scope.map, $scope.markers['order'][order.id]);
				}
			}
		}

		$scope.$on('updateOrder', function (event, data, nextParams, fromState) {
			var order = find($scope.data.orders, data.id);
			angular.merge(order, data);
			$scope.createOrderMarker(order);
		});

		$scope.$on('refreshDashboard', function (event, data, nextParams, fromState) {
			$scope.init();
		});

		$scope.$on('deleteOrder', function (event, data, nextParams, fromState) {
			var index = $scope.data.orders.indexOf($filter('filter')($scope.data.orders, {
				id: data.id
			})[0]);
			if (index > -1)
				$scope.data.orders.splice(index, 1);
			$scope.map.geoObjects.remove($scope.orderMarkers[data.order.id]);
		});

		$scope.disableEnter = function (e) {
			if (e.keyCode == 13) {
				return false;
			}
		}

		$scope.getWorkerStatus = function (status) {
			if (typeof $scope.data !== 'undefined')
				return $filter('filter')($scope.data.workers, {
					status: status
				}).length;
		}

		$scope.checkLastLocationTime = function (worker) {
			if (worker.location_info.length > 0) {
				var extra = angular.fromJson(worker.location_info);
				var now = moment(new Date());
				var end = moment(extra.timestamp);
				var duration = moment.duration(now.diff(end));
				var hours = duration.asHours();
				return hours > 12;
			}
		}

		$scope.detailsWorker = function (worker) {
			$scope.sWorker = worker;
			if ($scope.sWorker.location_info.length != 0) {
				Order.getLatAndLngOfWorkerOrders({
					workerID: worker['id'],
					workerLatAndLng: Number($scope.sWorker.lat) + ',' + Number($scope.sWorker.lon)
				}).success(function (data, status, headers, config) {
					if (typeof data['latAndLng'] != "undefined" && typeof data['ids'] != "undefined") {

						var start = data['latAndLng'][0];
						var end = data['latAndLng'][data['latAndLng'].length - 1];
						var waypts = [];
						for (var i = 1; i < data['latAndLng'].length - 1; i++) {
							token = data['latAndLng'][i].split(',');
							var point = new ymaps.Point(Number(token[0]), Number(token[1]));
							waypts.push({
								'location': point,
								"stopover": true
							});
						}
						makeRoute(start, end, waypts, data['ids']);

					} else if (typeof data['latAndLng'] === "undefined" && typeof data['ids'] === "undefined" && routeOptimizationWorkerOrders.length > 0) {

						for (var i = 1; i < routeOptimizationWorkerOrders.length; i++) {
							$scope.orderMarkers[routeOptimizationWorkerOrders[i]].options.set('iconContentLayout', ymaps.templateLayoutFactory.createClass('<div class="map-marker"><img src="/img/icons/continue.png" alt="" width="30px"></div>'));
						}
						routeOptimizationDirectionsDisplay.setMap(null);
					}

					var location = [Number($scope.sWorker.lat), Number($scope.sWorker.lon)];
					$scope.map.setCenter(location);
					$scope.map.setZoom(15);
					$scope.infowindows.forEach(function (element) {
						element.close();
					}, this);
					infoWindow(worker, 'open');

				});
			}

		}

		$scope.clickWork = function (work) {
			$scope.selectedOrderId = work.id;
			$scope.infowindowsOrder.forEach(function (element) {
				element.close();
			}, this);
			$scope.orderMarkers[work.id].balloon.open();
			$scope.map.setCenter([Number(work.customer.latitude), Number(work.customer.longitude)]);
			$scope.map.setZoom(13);

			$scope.orderMarkers[work.id].events.add('balloonclose', function () {
				$scope.selectedOrderId = 0;
			});
		}

		$scope.closeWorker = function () {
			delete $scope.sWorker;
			for (var i = 1; i < routeOptimizationWorkerOrders.length; i++) {
				$scope.orderMarkers[routeOptimizationWorkerOrders[i]].options.set('iconContentLayout', ymaps.templateLayoutFactory.createClass('<div class="map-marker"><img src="/img/icons/continue.png" alt="" width="30px"></div>'));
			}
			if (routeOptimizationDirectionsDisplay.length > 0)
				routeOptimizationDirectionsDisplay.setMap(null);
		}

		$scope.filterWorker = function (worker) {
			if ($scope.statuses['worker'] == 0)
				return worker.status === 0;
			else if ($scope.statuses['worker'] == 1)
				return worker.status === 1;
			else
				return true;
		}

		$scope.setStatus = function (status, type) {
			$scope.statuses[type] = status;
		}

		$scope.getWorkStatus = function (status) {
			if (typeof $scope.data !== 'undefined' && typeof $scope.data.orders !== 'undefined') {
				if (status == 'continue') {
					return $filter('filter')($scope.data.orders, function (value) {
						return value.status == null || (value.status.id != $scope.data.complete && value.status.id != $scope.data.fail);
					}).length;
				} else if (status == 'cancel') {
					return $filter('filter')($scope.data.orders, function (value) {
						return value.status != null && value.status.id == $scope.data.fail;
					}).length;
				} else if (status == 'success') {
					return $filter('filter')($scope.data.orders, function (value) {
						return value.status != null && value.status.id == $scope.data.complete;
					}).length;
				} else if (status == 'assign') {
					return $filter('filter')($scope.data.orders, function (value) {
						return value.worker_id != 0;
					}).length;
				} else if (status == 'not-assign') {
					return $filter('filter')($scope.data.orders, function (value) {
						return value.worker_id == 0;
					}).length;
				} else if (status == 'other') {
					return $filter('filter')($scope.data.orders, function (value) {
						return value.status != null && (value.status.id == $scope.data.complete || value.status.id == $scope.data.fail);
					}).length;
				}
			}
		}

		$scope.filterWork = function (work) {
			if ($scope.statuses['work'] == 1) {
				return work.status == null || (work.status.id != $scope.data.complete && work.status.id != $scope.data.fail);
			} else if ($scope.statuses['work'] == 0) {
				return work.status != null && (work.status.id == $scope.data.fail);
			} else if ($scope.statuses['work'] == 2) {
				return work.status != null && (work.status.id == $scope.data.complete);
			}
		}

		$scope.refreshOrders = function () {
			Order.refreshOrders().success(function (data, status, headers, config) {
				$scope.data.orders = data.orders;
			});
		};

		$scope.$on('worker_answer', function (event, data, nextParams, fromState) {
			var order = find($scope.data.orders, data.order.id);
			angular.merge(order, data.order);
			$scope.createOrderMarker(order);
			Messenger().post(data.order.id + ' Nolu işin durumu "' + order.status.name + '" olarak değiştirildi.', 'İş Durumu!');
			Push.create('İş Durumu!', {
				body: data.order.id + ' Nolu işin durumu "' + order.status.name + '" olarak değiştirildi.',
				icon: {
					x32: 'https://s3.eu-central-1.amazonaws.com/herodispatcher/' + $scope.authenticatedUser.logo
				},
				timeout: 3000
			});
		});

		$scope.$on('location_update', function (event, data, nextParams, fromState) {
			if ($scope.selectedTeamName.id != null && $scope.selectedTeamName.id != data.worker.team_id) return false;

			var workerFind = find($scope.data.workers, data.worker.id);

			$scope.createWorkerMarker(data.worker);
			angular.merge(workerFind, data.worker);
		});

		$scope.$on('delete_order', function (event, data, nextParams, fromState) {
			$scope.refreshOrders();
		});

		$scope.$on('update_order', function (event, data, nextParams, fromState) {
			$scope.refreshOrders();
		});

		$scope.$on('worker_status', function (event, data, nextParams, fromState) {
			if ($scope.selectedTeamName.id != null && $scope.selectedTeamName.id != data.worker.worker.team_id) return false;

			if (data.status == 1) {
				var message = data.worker.full_name + ' İş Alımını Açtı!';
				Messenger().post(message);
				Push.create('Durum!', {
					body: message,
					icon: {
						x32: 'https://s3.eu-central-1.amazonaws.com/herodispatcher/' + $scope.authenticatedUser.logo
					},
					timeout: 3000
				});
			} else if (data.status == 0) {
				var message = data.worker.full_name + ' İş Alımını Kapattı!';
				Messenger().post({
					message: message,
					type: 'error',
					showCloseButton: true
				});
				Push.create('Durum!', {
					body: message,
					icon: {
						x32: 'https://s3.eu-central-1.amazonaws.com/herodispatcher/' + $scope.authenticatedUser.logo
					},
					timeout: 3000
				});
			} else if (data.status == 3) {
				if (data.gps) {
					var message = data.worker.full_name + ' GPS\'ni Açtı!';
					Messenger().post(message);
				} else {
					var message = data.worker.full_name + ' GPS\'ni Kapattı!';
					Messenger().post({
						message: message,
						type: 'error',
						showCloseButton: true
					});
				}
			} else if (data.status == 'note') {
				var order = find($scope.data.orders, data.log.order_id);
				if (typeof order !== 'undefined') {
					if (typeof order.notes === 'undefined') order.notes = [];
					order.notes.push(data.log);
				}
				Messenger().post({
					message: data.worker.full_name + ',  #' + data.log.order_id + ' nolu işe "' + data.log.reason + '" notunu ekledi!',
					type: 'success',
					showCloseButton: true
				});
				Push.create('İş Notu!', {
					body: data.worker.full_name + ',  #' + data.log.order_id + ' nolu işe "' + data.log.reason + '" notunu ekledi!',
					icon: {
						x32: 'https://s3.eu-central-1.amazonaws.com/herodispatcher/' + $scope.authenticatedUser.logo
					},
					timeout: 3000
				});
			}
			if (data.status != 'note') {
				var worker = find($scope.data.workers, data.worker.worker.id);
				worker.status = data.status;
				worker.location_info = data.worker.worker.location_info;
				$scope.changeWorkerMarker(worker);
			}
		});

		function find(data, find) {
			var index = data.indexOf($filter('filter')(data, {
				id: find
			})[0]);
			if (index > -1)
				return data[index];
		}

		$scope.updateOrder = function (e) {
			Order.updateOrder($scope.editOrderData).success(function (data, status, headers, config) {
				var index = $scope.data.orders.indexOf($filter('filter')($scope.data.orders, {
					id: $scope.editOrderData.id
				})[0]);
				if (index > -1) {
					$scope.data.orders[index] = data;
					$('#orderEdit').modal('hide');
				}
			}).error(function () {
				alert('Şuan bir hata oluştu lütfen daha sonra yeniden deneyiniz.');
			});
		};

		$scope.calculateDiff = function (start, end) {
			return moment(end).diff(moment(start), 'minute');
		}

		$scope.getBatteryInfo = function (worker) {
			if (worker.location_info.length != 0) {
				var extra = angular.fromJson(worker.location_info);
				if (typeof extra.battery !== 'undefined')
					return parseFloat(extra.battery * 100).toFixed(0);
			} else {
				return 'Bilgi Yok';
			}
		}

		$scope.getLastLocationTime = function (worker) {
			if (worker.location_info.length > 0) {
				var extra = angular.fromJson(worker.location_info);
				return moment(extra.timestamp).format('D MMM, HH:mm');
			} else {
				return 'Bilgi Yok';
			}
		}

		function infoWindow(data, type) {
			if ($scope.workerMarkers[data.id]) {

				var extra = angular.fromJson(data.location_info),
					content = '<div id="iw-container">' +
						'<div class="iw-content"> <div class="btn-group pull-right">' +
						'<button type="button" onclick="angular.element(this).scope().$apply(function() { angular.element(this).scope().zoomIn(' + data.lat + ', ' + data.lon + '); })" class="btn btn-xs btn-warning">Yaklaş</button>' +
						'<button type="button" onclick="angular.element(this).scope().$apply(function() { angular.element(this).scope().getWorkerDetails(' + data.id + '); })" class="btn btn-xs btn-primary">Detaylar</button> </div>' +
						'<div class="iw-subTitle">' + data.full_name + '</div>' +
						'<img src="https://s3.eu-central-1.amazonaws.com/herodispatcher/' + data.profile_photo + '" class="img-circle" height="90" width="90">' +
						//'<p><strong> Şarj : </strong>'+Math.round(extra.battery * 100 )+' %</p>' +
						'<p><strong> Doğruluk : </strong>' + Math.round(extra.accuracy) + ' Metre</p>';
				// '<p><strong> Hareket Durumu : </strong>'+getActivity(extra.activity)+'</p>';

				if ($scope.authenticatedUser.setting.last_location_time) {
					content += '<p><strong> Son Konum Zamanı :</strong>' + moment(extra.timestamp).format('D MMM, HH:mm');
				}
				content += '</div></div>';
				var infowindow = new ymaps.Balloon({
					content: content,
					maxWidth: 360
				});
				$scope.workerMarkers[data.id].events.add('click', function (e) {
					e.stopPropagation();
					setTimeout(function() {
						$scope.$apply(function() {
							infowindow.open($scope.map, $scope.workerMarkers[data.id].geometry.getCoordinates());
						});
					}, 100);
				});

				if (typeof $scope.infowindows[data.id] === 'undefined') {
					$scope.infowindows[data.id] = infowindow;
				} else {
					$scope.infowindows[data.id].setContent(content);
				}

				if (type == 'open') $scope.infowindows[data.id].open($scope.map, $scope.workerMarkers[data.id].geometry.getCoordinates());
			}
		}

		function getActivity(activity) {
			var type = '';
			switch (activity) {
				case 'still':
					type = 'Beklemede';
					break;
				case 'on_foot':
					type = 'Yürüyüş';
					break;
				case 'in_vehicle':
					type = 'Araçta';
					break;
				case 'on_bicycle':
					type = 'Motor - Bisiklet';
					break;
				case 'running':
					type = 'Yürüyüş';
					break;

				default:
					type = 'Tanımlanamadı';
					break;

			}
			return type;
		}

		$scope.changeWorkerMarker = function (worker) {
			if (typeof $scope.workerMarkers[worker.id] !== 'undefined') {

				var iconColor = worker.icon_color;

				$scope.workerMarkers[worker.id].options.set('iconContentLayout', ymaps.templateLayoutFactory.createClass('<div class="map-worker-marker"><img src="/img/icons/worker_' + worker.status + '.png" alt="" width="30px"></div>'));
				$scope.workerMarkers[worker.id].options.set('iconColor', iconColor);

				infoWindow(worker);
			}
		}

		$scope.zoomIn = function (lat, lng) {
			$scope.map.setCenter([lat, lng]);
			$scope.map.setZoom(16);
		}

		$scope.getNumber = function (num) {
			return new Array(num);
		}

		function createContextMenu() {
			var contextMenuOptions = {
				classNames: {
					menu: 'dropdown-menu',
					menuSeparator: 'divider'
				},
				menuItems: [{
					className: 'item',
					eventName: 'create_order',
					label: 'Buraya Noktaya İş Oluştur'
				},
				{},
				{
					className: 'item',
					eventName: 'center_map_click',
					label: 'Haritayı Ortala'
				},
				{
					className: 'item',
					eventName: 'zoom_in_click',
					label: 'Yaklaş'
				},
				{
					className: 'item',
					eventName: 'zoom_out_click',
					label: 'Uzaklaş'
				}
				],
				pixelOffset: new ymaps.Point(10, -5),
				zIndex: 5
			};
			//	create the ContextMenu object
			var contextMenu = new ymaps.ContextMenu($scope.map, contextMenuOptions);

			//	display the ContextMenu on a Map right click
			$scope.map.events.add('contextmenu', function (mouseEvent) {
				contextMenu.show(mouseEvent.get('coords'));

			});

			$scope.map.events.add('contextmenuclose', function () {
				contextMenu.hide();
			});

			$scope.map.events.add('click', function (e) {
				if (contextMenu.isOpen()) {
					contextMenu.hide();
				}
			});

			$scope.map.events.add('contextmenuitemclick', function (e) {
				var eventName = e.get('menuItem').options._data.eventName;
				var coords = e.get('coords');
				switch (eventName) {
					case 'zoom_in_click':
						$scope.map.setZoom($scope.map.getZoom() + 1);
						break;
					case 'zoom_out_click':
						$scope.map.setZoom($scope.map.getZoom() - 1);
						break;
					case 'center_map_click':
						$scope.map.setCenter(coords);
						break;
					case 'create_order':
						geocoder = new ymaps.Geocoder();
						geocoder.geocode({
							'coords': coords
						}, function (results, status) {
							if (status === ymaps.geocode.Status.OK) {
								var componentForm = {
									street_number: 'short_name',
									route: 'long_name',
									locality: 'long_name',
									administrative_area_level_1: 'short_name',
									administrative_area_level_2: 'short_name',
									country: 'long_name',
									postal_code: 'short_name'
								},
									mapping = {
										street_number: 'number',
										route: 'street',
										locality: 'state',
										administrative_area_level_1: 'city',
										administrative_area_level_2: 'district',
										country: 'country',
										postal_code: 'zip'
									},
									details;
								for (var i = 0; i < results.geoObjects.length; i++) {
									var addressType = results.geoObjects[i].properties.get('metaDataProperty.GeocoderMetaData.AddressDetails.Country.AddressField[0].types[0]');
									if (componentForm[addressType]) {
										var val = results.geoObjects[i].properties.get('metaDataProperty.GeocoderMetaData.AddressDetails.Country.AddressField[0].Name');
										details[mapping[addressType]] = val;
									}
								}
								details.formatted = results.geoObjects[0].properties.get('text');
								details.address = results.geoObjects[0].properties.get('text');
								details.placeId = results.geoObjects[0].properties.get('metaDataProperty.GeocoderMetaData.AddressDetails.Country.AddressField[0].AddressLine');
								console.log(details);
							}
						});
						break;
				}
			});
		}

		$scope.getAddressFromCoord = function (coord) {

			if (coord.lat != '') {
				var url = "//maps.googleapis.com/maps/api/geocode/json?latlng=" + coord.lat + "," + coord.lon + "&key=AIzaSyDxjEa1-VMmyYdudc4Vmsfa8XBGlnxubco";
				Order.getAddressFromCoord(url).success(function (data, status, headers, config) {
					console.log(angular.fromJson(data));
				});
			}
		}

		$scope.sidebar = function (e) {
			if (e == 'left') {
				$scope.filterPanel = false;
				$("#sidebar_right").toggle();
				if (!$("#sidebar_right").is(":visible"))
					$(".sidebar_left_toggle").css({
						left: 0
					}).html('<i class="fa fa-arrow-right"></i>');
				else
					$(".sidebar_left_toggle").css({
						left: '310px'
					}).html('<i class="fa fa-arrow-left"></i>');
			} else {
				$(".sidebar_worker").toggle();
				if (!$(".sidebar_worker").is(":visible"))
					$(".sidebar_right_toggle").css({
						right: 0
					}).html('<i class="fa fa-arrow-left"></i>');
				else
					$(".sidebar_right_toggle").css({
						right: '260px'
					}).html('<i class="fa fa-arrow-right"></i>');
			}
		}

		var directionsService = [],
			directionsDisplay = [];

		$scope.getRemainingTime = function (id, loading, direction) {

			Order.remainingTime(id, loading).success(function (data, status, headers, config) {
				var order = find($scope.data.orders, id);

				order.dist = data.dist;

				if (calculatedOrder.indexOf(id) == -1)
					calculatedOrder.push(id);

				if (typeof direction === 'undefined') {

					directionsService[order.id] = new ymaps.route.Route([
						[Number(data.coords[0].lat), Number(data.coords[0].lon)],
						[Number(data.coords[1].lat), Number(data.coords[1].lon)],
						[Number(data.coords[2].lat), Number(data.coords[2].lon)],
						[Number(data.coords[3].lat), Number(data.coords[3].lon)]
					], {
						avoidTraffic: true
					});

					directionsDisplay[order.id] = new ymaps.GeoObjectCollection({}, {
						draggable: false
					});

					$scope.map.geoObjects.add(directionsDisplay[order.id]);
					directionsDisplay[order.id].add(directionsService[order.id]);
				}

				if (typeof $scope.calculaterInterval == 'undefined') {
					$scope.calculaterInterval = setInterval(function () {
						calculatedOrder.forEach(function (element) {
							$scope.getRemainingTime(element, true, false);
						});
					}, 60000);
				}

			});
		};

		function makeRoute(start, end, waypts, allID) {
			console.log(allID)
			if (routeOptimizationWorkerOrders.length > 0) {

				for (var i = 1; i < routeOptimizationWorkerOrders.length; i++) {
					$scope.orderMarkers[routeOptimizationWorkerOrders[i]].options.set('iconContentLayout', ymaps.templateLayoutFactory.createClass('<div class="map-marker"><img src="/img/icons/continue.png" alt="" width="30px"></div>'));
				}
				routeOptimizationDirectionsDisplay.setMap(null);
			}


			var directionsDisplay;
			var directionsService = new ymaps.route.Route([
				start,
				end
			], {
				avoidTraffic: true
			});

			directionsDisplay = new ymaps.GeoObjectCollection({}, {
				draggable: false
			});

			$scope.map.geoObjects.add(directionsDisplay);
			directionsDisplay.add(directionsService);

			waypts.forEach(function (waypt) {
				directionsService.addWayPoint(waypt.location);
			});

			routeOptimizationDirectionsDisplay = directionsDisplay;
			routeOptimizationWorkerOrders = allID;
		}
	}
]);